<template>
  <div class="goods-bottom">
      <!-- <div class="operation" @click.stop="$emit('collectGoods', prodects, index)">
      <img :src="collectIcon" alt="">
    </div>
    <div class="operation" @click.stop="addCart">
      <img src="https://fr-static.shopshops.top/20210402/cart.77db0481c11bb345.svg" alt="">
    </div> -->
    
       <div class="operation">
      <img src="@/assets/imgs/anchor/colloct.png" alt="">
    </div>
    <div class="operation">
      <img src="@/assets/imgs/anchor/chat.png" alt="">
    </div>

  </div>
</template>
<script>
export default {
    props: {
        prodects: Object,
        index: Number
    },
    data() {
        return {}
    },
    computed: {
        normal() {
            // 正常情况
            return this.prodects.showAppStatus && this.prodects.shelfStatus && this.prodects.stock;
        },
        sellOut() {
            // 已售罄
            return (
                !this.prodects.stock &&
                !this.prodects.lockStock &&
                this.prodects.showAppStatus
            );
        },
        shelf() {
            // 已下架
            return this.prodects.showAppStatus && !this.prodects.shelfStatus;
        },
        collectIcon() {
            // 收藏图标
            return this.prodects.isLike
                ? 'https://fr-static.shopshops.top/20210406/collectionlight.bdde7ba9c53d1590.png'
                : 'https://fr-static.shopshops.top/20210402/collection.660af7299a8f1b1e.svg';
        },
    },
    methods: {
        addCart() {
            if (this.normal) {
                //todo: 添加购物车
                // addToCart({
                //     goodsId: this.prodects.id,
                //     H5_Source: 6
                // })
            } else {
                this.toGoodsDetail(this.prodects)
            }
        },
        toGoodsDetail(good) {
             this.$router.push({
                    path: '/app/goods_detail',
                    query: {
                        goodsId: good.id
                    }
                })
        }
    }
}
</script>
<style lang="less" scoped>
.goods-bottom{
  display: flex;
  justify-content: space-between;
  height: 20px;
  margin-top: 12px;
  .operation{
    border-right: 0.5px solid rgba(255,255,255,0.05);
    img{
      width: 20px;
      vertical-align: top;
    }
  }
}
</style>